import { c as _c } from "react/compiler-runtime";
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
export default function Methodology() {
  const $ = _c(3);
  const {
    methodology
  } = useReviewContext();
  if (!methodology) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography component="h3" fontWeight={500} fontSize="1.3rem" lineHeight={1.5}>Methodology</Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== methodology) {
    t1 = <FeatureViewed entityName="accordion" entitySection="methodology" impressionPosition={8}><Grid display="flex" flexDirection="column" gap={4} mb={5}>{t0}<StructuredContentRenderer doc={methodology} /></Grid></FeatureViewed>;
    $[1] = methodology;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}